import React from 'react';
import PropTypes from 'prop-types';
import FindCustodianForm from './FindCustodianForm';
import ManualCustodianForm from './ManualCustodianForm';

const Custodian = ({
  handleNext,
  skipPreviousStep,
  setIsManual,
  isManual,
  shouldClearForm,
  setShouldClearForm,
}) => (
  <>
    {isManual ? (
      <ManualCustodianForm
        handleNext={handleNext}
        setIsManual={setIsManual}
        isManual={isManual}
        shouldClearForm={shouldClearForm}
        setShouldClearForm={setShouldClearForm}
      />
    ) : (
      <FindCustodianForm
        handleNext={handleNext}
        setIsManual={setIsManual}
        skipPreviousStep={skipPreviousStep}
        setShouldClearForm={setShouldClearForm}
      />
    )}
  </>
);

Custodian.propTypes = {
  handleNext: PropTypes.func,
  skipPreviousStep: PropTypes.func,
  setIsManual: PropTypes.func,
  isManual: PropTypes.bool,
  shouldClearForm: PropTypes.bool,
  setShouldClearForm: PropTypes.func,
};

export default Custodian;
